function setHeights() {

    // Add padding to <body> according to fixed header
    $headerHeight = $('header').outerHeight();
    $footerHeight = $('footer').outerHeight();
    $('body').css('padding-top', $headerHeight);
    $('.searchPanel .searchBar').css('height', $headerHeight);

}


$(window).resize(function () {

    setHeights();

});

$(document).ready(function () {

    setHeights();

    // Hide <header> on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 1;
    var navbarHeight = $('header').outerHeight() + 100;

    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    });

    function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            topBarHeight = $('.topBar').outerHeight();
            $('header').css('top', '-' + topBarHeight + 'px');
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('header').css('top', 0);
            }
        }

        lastScrollTop = st;
    }


    // announcementBar
    var aBar = $('.announcementBar');
    if (Cookies.get('announcementBar') == null) {
        aBar.slideDown();
        setTimeout(function () {
            setHeights();
        }, 500);
    }

    $('.announcementBar .closeBar').click(function (e) {
        e.preventDefault();
        aBar.slideUp();

        Cookies.set('announcementBar', {expires: 1});

        setTimeout(function () {
            setHeights();
        }, 500);
    });


    // Navigation
    var navigation = $('.navigation');
    var noDropdownLink = $('.navigation > ul > li:not(.has-dropdown)');
    var dropdownLink = $('.navigation > ul > li.has-dropdown > a');
    var dropdown = $('.navigation .megaDropdown, .navigation .dropdown');
    var megaLink = $('.navigation .megaDropdown .childlists > li > a.has-children');

    if ($(window).width() > 768) {
        dropdownLink.hoverIntent(function () {
            dropdown.removeClass('visible');
            $(this).parent().find(dropdown).addClass('visible');
        });
        dropdown.on('mouseleave', function () {
            $(this).removeClass('visible');
        });
        noDropdownLink.on('mouseenter', function () {
            dropdown.removeClass('visible');
        });
    } else {
        dropdownLink.click(function (e) {
            e.preventDefault();
            $(this).parent().find(dropdown).addClass('visible');
        });
        megaLink.click(function (e) {
            e.preventDefault();
            $(this).parent().find('ul').addClass('visible');
        });
    }

    $('.megaDropdown .mobileTitle').click(function (e) {
        e.preventDefault();
        $(this).parent().removeClass('visible');
    })


    // Nav trigger
    $('.navToggle').click(function (e) {
        $('body').toggleClass('noScroll');
        $(this).find('.hamburger').toggleClass('open');
        $('.navigation').toggleClass('open');
        dropdown.removeClass('visible');
    });


    // Mobile search trigger
    $('.searchToggle').click(function (e) {
        e.preventDefault();
        $('.mobileSearch').slideToggle();
        $('.mobileSearch').find('.form-control').focus();
    });


    // Product tabs
    $('.tab').hide();
    $('.tab:first').show();
    $('.tabs li:first').addClass('active');
    $('.tabs li').click(function (e) {
        e.preventDefault();
        $('.tabs li').removeClass('active');
        $(this).addClass('active');
        $('.tab').hide();
        var selectTab = $(this).find('a').attr("href");
        $(selectTab).fadeIn();
    });

    // tooltip
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })


});


$(window).load(function () {

    // Owl carousel
    /* Home slider */
    $('.homeSlider').owlCarousel({
        dots: true,
        nav: true,
        loop: true,
        autoplay: true,
        autoplaySpeed: 3000,
        autoplayHoverPause: true,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        items: 1,
        navText: ["<i class='fal fa-long-arrow-left'></i>", "<i class='fal fa-long-arrow-right'></i>"]
    });
    $('.homeSlider').on('changed.owl.carousel', function (property) {
        var item = property.item.index; // Position of the current item
        $('.content').removeClass('animated fadeInUp');
        $(property.target).find(".owl-item").eq(item).find('.content').addClass('animated fadeInUp');
    });

    /* Products slider */
    $('.products-slider').owlCarousel({
        dots: false,
        nav: true,
        loop: false,
        autoplay: false,
        items: 4,
        navText: ["<i class='fal fa-long-arrow-left'></i>", "<i class='fal fa-long-arrow-right'></i>"],
        responsive: {
            0: {
                items: 2
            },
            1024: {
                items: 4
            }
        }
    });

    /* Product images slider */
    var sync1 = $(".productImages");
    var sync2 = $(".productThumbs");
    var slidesPerPage = 5;
    var syncedSecondary = true;

    sync1.owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: true,
        autoplay: false,
        autoHeight: true,
        dots: true,
        loop: true,
        responsiveRefreshRate: 200,
        navText: ["<i class='fal fa-angle-left'></i>", "<i class='fal fa-angle-right'></i>"],
    }).on('changed.owl.carousel', syncPosition);

    sync2.on('initialized.owl.carousel', function () {
        sync2.find(".owl-item").eq(0).addClass("current");
    })
        .owlCarousel({
            items: slidesPerPage,
            dots: true,
            nav: true,
            autoWidth: true,
            smartSpeed: 200,
            slideSpeed: 500,
            slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
            responsiveRefreshRate: 100,
            navText: ["<i class='fal fa-angle-left'></i>", "<i class='fal fa-angle-right'></i>"],
        }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        //if you set loop to false, you have to restore this next line
        //var current = el.item.index;

        //if you disable loop you have to comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }

        //end block

        sync2.find(".owl-item").removeClass("current").eq(current).addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });

});


// Cart
$(window).load(function () {
    stage.init();

    $('header .buttons .cartToggle').click(function (event) {
        stage.toggleCartDrawer();
    });

    $('.cartDrawer .closeCartDrawer').click(function (event) {
        stage.closeCartDrawer();
    });
});

var stage = {
    init: function () {
        this.initAddToCart();
        this.initItemAddToCart();
        this.initDropDownCart();
    },
    initAddToCart: function () {
        $('#add').click(function (event) {
            event.preventDefault();
            if ($(this).attr('disabled') != 'disabled') {
                var variant_id = $('#addToCartForm select[name=id]').val();
                if (!variant_id) {
                    variant_id = $('#addToCartForm input[name=id]').val();
                }
                var quantity = $('#addToCartForm input[name=quantity]').val();
                if (!quantity) {
                    quantity = 1;
                }
                // check for upsells
                var upsell = false
                if ($(this).hasClass('upsell')) {
                    upsell = true
                }
                stage.addToCart(variant_id, quantity, upsell);
            }
            return false;
        });
    },
    initItemAddToCart: function () {
        $('.add').click(function (event) {
            event.preventDefault();
            if ($(this).attr('disabled') != 'disabled') {
                var variant_id = $(this).parent().find('input[name=id]').val();
                var quantity = $(this).parent().find('input[name=quantity]').val();
                if (!quantity) {
                    quantity = 1;
                }
                stage.addToCart(variant_id, quantity);
                $.fancybox.close('#upsellModal')
            }
            return false;
        });
    },
    initDropDownCart: function () {
        stage.checkDropdownCart();

        $('.cartDrawer .removeItem').click(function (event) {
            event.preventDefault();
            var productId = $(this).parents('.cartItem').attr('id');
            Shopify.removeItem(productId, function (cart) {
                stage.updateDropdownCart(cart);
            });
        });
    },
    addToCart: function (variant_id, quantity, upsell) {
        $.ajax({
            type: 'post',
            url: '/cart/add.js',
            data: 'quantity=' + quantity + '&id=' + variant_id,
            dataType: 'json',
            success: function (msg) {
                stage.initUpdateDropdownCart(upsell);
                if (upsell) {
                    $.fancybox.open({
                        src: '#upsellModal',
                        touch: false
                    })
                }
            },
            error: function (xhr, text) {
                $.fancybox.open('<div class="error"><p>' + $.parseJSON(xhr.responseText).description + '</p></div>');
            }
        });
    },
    initUpdateDropdownCart: function (upsell) {
        Shopify.getCart(function (cart) {
            stage.updateDropdownCart(cart, upsell);
        });
    },
    updateDropdownCart: function (cart, upsell) {
        var template = '<div class="cartItem animated fadeIn" id="{ID}">' +
            '<a href="{URL}" title="{TITLE}" class="image">' +
            '<img src="{IMAGE}" alt="{TITLE}">' +
            '</a>' +
            '<div class="details">' +
            '<a href="{URL}" class="title">{TITLE}</a>' +
            '<div class="variant">{VARIANT}</div>' +
            '<div class="total"><span class="price">{PRICE}</span>{QUANTITY}</div>' +
            '</div>' +
            '<a href="#" class="removeItem"><i class="fal fa-times"></i></a>' +
            '</div>';

        $('.cartCount').text(cart.item_count);
        /*Total price*/
        $('.cartDrawer .summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
        /*Clear cart*/
        $('.cartDrawer .items').html('');
        /*Add product to cart*/
        if (cart.item_count > 0) {
            for (var i = 0; i < cart.items.length; i++) {
                var item = template;
                item = item.replace(/\{ID\}/g, cart.items[i].id);
                item = item.replace(/\{URL\}/g, cart.items[i].url);
                item = item.replace(/\{TITLE\}/g, cart.items[i].product_title);
                if (cart.items[i].variant_title != null) {
                    item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title);
                } else {
                    item = item.replace(/\{VARIANT\}/g, '');
                }
                if (cart.items[i].quantity > 1) {
                    item = item.replace(/\{QUANTITY\}/g, ' x ' + cart.items[i].quantity);
                } else {
                    item = item.replace(/\{QUANTITY\}/g, '');
                }
                item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'large'));
                item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
                $('.cartDrawer .items').append(item);
            }
            $('.cartDrawer .removeItem').click(function (event) {
                event.preventDefault();
                var productId = $(this).parents('.cartItem').attr('id');
                productId = productId.match(/\d+/g);
                Shopify.removeItem(productId, function (cart) {
                    stage.updateDropdownCart(cart);
                });
            });
        }
        stage.checkDropdownCart();

        if (!upsell) {
            stage.toggleCartDrawer()
        }
    },
    checkDropdownCart: function () {
        if ($('.cartDrawer .items').children().length > 0) {
            // Has item in dropdown cart
            $('.cartDrawer .emptyCart').hide();
            $('.cartDrawer .items, .cartDrawer .bottom').show();
        } else {
            // No item in dropdown cart
            $('.cartDrawer .items, .cartDrawer .bottom').hide();
            $('.cartDrawer .emptyCart').show();
        }
    },
    toggleCartDrawer: function () {
        var cartDrawer = $('.cartDrawer');
        var cartDrawerOverlay = $('.cartDrawerOverlay');

        event.preventDefault();
        if (!cartDrawer.hasClass('open')) {
            cartDrawer.addClass('open');
            cartDrawerOverlay.addClass('visible');
        }

        cartDrawerOverlay.click(function () {
            cartDrawer.removeClass('open');
            $(this).removeClass('visible');
        });
    },
    closeCartDrawer: function () {
        var cartDrawer = $('.cartDrawer');
        var cartDrawerOverlay = $('.cartDrawerOverlay');

        event.preventDefault();
        if (cartDrawer.hasClass('open')) {
            cartDrawer.removeClass('open');
            cartDrawerOverlay.removeClass('visible');
        }
    }
}
